import React, { useContext } from 'react';
import Context from './Context/SessionContext';
import APP from '../tools/AppRoutes';
import { withRouter } from "react-router-dom";
import Button from '@material-ui/core/Button';
import LogoutIcon from '@material-ui/icons/ExitToApp';

const Session = ({ history }) => {

    const { user, logout } = useContext(Context);
    const cerrarSesion = () => {
        logout();
        history.push(APP.INDEX);
    }

    if (user !== null && Object.keys(user).length > 0) {

        if (user !== undefined && user.Usuario) {
            return (
                <div className="float-right fontExo" style={{ fontSize: 12, alignItems: 'flex-start', display: 'flex', height: '31px', paddingTop: '5px' }}>
                    <label style={{ color: 'white' }} >Bienvenido(a):</label>
                    <label style={{ color: 'white' }} className="font-weight-bold">&nbsp;{user.NombreCompleto}</label>
                    <div style={{ height: '31px' }}>
                        <Button style={{ color: 'white', padding: '0px' }} variant="text" endIcon={<LogoutIcon />} onClick={cerrarSesion}></Button>
                    </div>

                </div>
            )
        } else {
            return (
                <div></div>
            )
        }
    }
    else {
        return (
            <div></div>
        )
    }
}

export default withRouter(Session);
